/*
 * @Author: zhechuan.Wang
 * @Date: 2023-11-20 12:19:28
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-02-21 08:45:22
 * @Description: file content
 * @FilePath: \gfmis-card-ppt\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/index' // 首页
import SubsidizeProject from '@/views/subsidize/subsidizeProject' // 补贴项目公示
import SubsidizePubInfo from '@/views/subsidize/SubsidizePubInfo' // 补贴项目发放信息
import IssueDetail from '@/views/subsidize/issueDetail' // 补贴项目发放明细信息按项目
import IssueDetailBatch from '@/views/subsidize/issueDetailBatch' // 补贴项目发放明细信息按项目_发放批次
import PublicInfo from '@/views/issue/publicInfo'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: Home, // 路由懒加载
    meta: {
      titleObj: {
        cnName: '补贴项目公示(全省)',
        enName: 'SUBSIDY PROJECTS LIST'
      }
    }
  },
  {
    path: '/card-pu',
    component: Home,
  },
  {
    path: '/card-pu/gov',
    component: Home,
  },
  {
    path: '/card-pu/dep',
    component: Home,
  },
  {
    path: '/card-pu/agency',
    component: Home,
  },
  {
    path: '/card-pu/subsidizeProject',
    name: 'SubsidizeProject',
    component: SubsidizeProject,
    meta: {
      titleObj: {
        cnName: '补贴项目公示',
        enName: 'SUBSIDY PROJECTS LIST'
      }
    }
  },
  {
    path: '/card-pu/detailSearch',
    name: 'detailSearch',
    component: () => import('../views/subsidize/detailSearch.vue'),
    meta: {
      titleObj: {
        cnName: '发放信息公示',
        enName: 'SUBSIDIES'
      }
    }
  },
  {
    path: '/card-pu/notification',
    name: 'notification',
    component: () => import('../views/subsidize/notification.vue'),
    meta: {
      titleObj: {
        cnName: '发放信息公示',
        enName: 'SUBSIDIES'
      }
    }
  },
  {
    path: '/card-pu/publicInfo',
    name: 'PublicInfo',
    component: PublicInfo,
    meta: {
      titleObj: {
        cnName: '发放信息公示',
        enName: 'SUBSIDIES'
      }
    }
  },
  {
    path: '/card-pu/subsidize/publicInfo',
    name: 'SubsidizePubInfo',
    component: SubsidizePubInfo,
  },
  // 补贴政策项目发放明细按项目
  {
    path: '/card-pu/subsidize/issueDetail',
    name: 'IssueDetail',
    component: IssueDetail,
  },
  // 补贴政策项目发放明细按项目_发放批次
  {
    path: '/card-pu/subsidize/issueDetailBatch',
    name: 'IssueDetailBatch',
    component: IssueDetailBatch,
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
// router.beforeEach((to, from, next) => {
// console.log('==to.path==', to.path)
// if (to.path == "/card-pu/gov") {
//   next('/')
// } else {
//   next()
// }
// next()
// })

export default router
